import React, { useEffect, useState } from "react";
import { FolderPlus, Loader2 } from "lucide-react";
import { api, errorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

export function BulkProjectDialog({ ids, open, onOpenChange, onDone }) {
  const { t } = useI18n();
  const [projects, setProjects] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { if (open) api.get("/projects").then((r) => setProjects(r.data)); }, [open]);
  const add = async (p) => {
    setBusy(p.id);
    try {
      const { data } = await api.post(`/projects/${p.id}/entries/bulk`, { candidate_ids: ids });
      toast.success(t("{{count}} profiles added to {{name}}", { count: data.added.length, name: p.title }) + (data.already.length ? ` · ${t("{{count}} already in the project", { count: data.already.length })}` : ""));
      onDone(); onOpenChange(false);
    } catch (e) { toast.error(errorDetail(e)); } finally { setBusy(null); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="bulk-project-dialog">
        <DialogHeader><DialogTitle>{t("Add {{count}} profiles to a project", { count: ids.length })}</DialogTitle>
          <DialogDescription>{t("They are placed in the first stage of the pipeline. Profiles already in the project are skipped.")}</DialogDescription></DialogHeader>
        <div className="space-y-1 max-h-[50vh] overflow-y-auto">
          {!projects ? <div className="h-16 rounded-lg shimmer bg-muted" /> : !projects.length ? <p className="text-sm text-muted-foreground">{t("No projects yet.")}</p>
            : projects.map((p) => (
              <button key={p.id} disabled={!!busy} onClick={() => add(p)} data-testid={`bulk-project-${p.id}`}
                className="w-full flex items-center gap-2 text-left text-sm rounded-md border px-3 py-2 hover:bg-muted disabled:opacity-60">
                {busy === p.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <FolderPlus className="w-4 h-4 text-primary" />}
                <span className="flex-1">{p.title}</span><span className="text-xs text-muted-foreground">{t("{{count}} candidates", { count: p.candidate_count })}</span></button>))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
